import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CreateParaphrase from './CreateParaphrase'

const Paraphrase = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/`} component={CreateParaphrase} />
    </Switch>
  </div>
)
export default Paraphrase
